import { isEmpty } from 'lodash';

//----------------------------------------------------------------------
// CONSTANTS
//----------------------------------------------------------------------

export const APPLICATION_BUNDLE_VERSION =
  process.env.CITOOLS_CALCULATED_PACKAGE_VERSION ?? process.env.npm_package_version;

export const CRTVersions = {
  '6.18': '22CR4',
  '6.19': '23CR1',
  '6.20': '23CR2',
  '6.21': '23CR3',
  '6.22': '23CR4',
  '6.23': '24CR1',
  '6.24': '24CR2',
  '6.25': '24CR3',
  '6.26': '24CR4',
  '6.27': '25CR1',
  '6.28': '25CR2',
  '6.29': '25CR3',
  '6.30': '25CR4',
  '6.31': '26CR1',
  '6.32': '26CR2',
  '6.33': '26CR3',
  '6.34': '26CR4'
};

//----------------------------------------------------------------------
// UTILS
//----------------------------------------------------------------------

export function isSBX() {
  const urlParts = location.hostname.split('.');
  return urlParts.some((part) => part === 'sbx');
}

export function isMerlin() {
  if (window.surveyData && window.surveyData.specId) {
    const { specId } = window.surveyData;
    return specId.includes('merlin');
  }
  return false;
}

export function isLocalServer() {
  return location.hostname === 'localhost' || location.hostname === '127.0.0.1';
}

export function getCRTVersion(surveysVersion?: string | null) {
  if (!surveysVersion) {
    return 'Unknown';
  }

  const versionMatch = surveysVersion.match(/^(\d+\.\d+)/);

  if (!versionMatch) {
    return 'Unknown';
  }

  const majorMinor = versionMatch[1] as keyof typeof CRTVersions;

  if (majorMinor in CRTVersions) {
    return CRTVersions[majorMinor];
  } else {
    return 'Unknown';
  }
}

export function getApplicationVersion() {
  const documentScripts = Array.from(document.getElementsByTagName('script'))
    .map((item) => item.src)
    .filter((src) => !isEmpty(src));

  for (const script of documentScripts) {
    const version = extractVersion(script);

    if (version) {
      return version;
    }
  }

  return APPLICATION_BUNDLE_VERSION || 'Unknown';
}

function extractVersion(url: string) {
  const match = url.match(/\/(\d+\.\d+\.\d+(?:-[^\/]+)?)\/[^\/]*\.js$/);
  return match ? match[1] : null;
}
